import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { TagGi } from '../models/tag-gi';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class LoteProdutoService {


  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarPorIdProduto(idProduto: number, idCD) {

    let parametros = new HttpParams()
      .set('idProduto', idProduto.toString());

    if (idCD !== null && idCD !== undefined) {
      parametros = parametros.set('idCD', idCD);
    }

    return this.http.get<any>(globals.apiUrl + '/api/LoteProduto/BuscarPorIdProduto', {
      params: parametros
    });
  }

  consultarPedidos(lote: string, idProduto: number, idCD) {

    let parametros = new HttpParams()
      .set('lote', lote)
      .set('idProduto', idProduto.toString());

    if (idCD !== null && idCD !== undefined) {
      parametros = parametros.set('idCD', idCD);
    }

    return this.http.get<any>(globals.apiUrl + '/api/LoteProduto/BuscarPedidos', {
      params: parametros
    });
  }

  exportarPedidosDoLote(lote, idProduto, idCD) {

    let parametros = new HttpParams()
      .set('lote', lote)
      .set('idProduto', idProduto);

    if (idCD !== null && idCD !== undefined) {
      parametros = parametros.set('idCD', idCD);
    }

    return this.http.get(globals.apiUrl + '/api/LoteProduto/ExportarPedidosDoLote', {
      responseType: 'blob',
      params: parametros
    });
  }

  exportarLotesDoProduto(idProduto, idCD) {

    let parametros = new HttpParams()
      .set('idProduto', idProduto.toString());

    if (idCD !== null && idCD !== undefined) {
      parametros = parametros.set('idCD', idCD);
    }

    return this.http.get(globals.apiUrl + '/api/LoteProduto/ExportarLotesDoProduto', {
      responseType: 'blob',
      params: parametros
    });
  }

  consultarLotesPorIdCupom(idCupom: string, idProduto: number, idCD) {

    let parametros = new HttpParams()
      .set('idCupom', idCupom)
      .set('idProduto', idProduto.toString());

    if (idCD !== null && idCD !== undefined) {
      parametros = parametros.set('idCD', idCD);
    }

    return this.http.get<any>(globals.apiUrl + '/api/LoteProduto/BuscarLotesPorIdCupom', {
      params: parametros
    });
  }

  trocarDeLote(loteAntigo: string, loteNovo: string, qtd: number, idCupom: string, idProduto: number, idCD) {

    let parametros = new HttpParams()
      .set('loteAntigo', loteAntigo)
      .set('loteNovo', loteNovo)
      .set('qtd', qtd.toString())
      .set('idCupom', idCupom)
      .set('idProduto', idProduto.toString());

    if (idCD !== null && idCD !== undefined) {
      parametros = parametros.set('idCD', idCD);
    }

    return this.http.get<any>(globals.apiUrl + '/api/LoteProduto/TrocarDeLote', {
      params: parametros
    });
  }

}
